import { formatNumber } from '@/utils/number';

interface ClaimedApprovedAmountProps {
  claimed: number;
  approved: number;
}

export function ClaimedApprovedAmount({ claimed, approved }: ClaimedApprovedAmountProps) {
  return (
    <span className="tabular-nums">
      {formatNumber(claimed)}
      {approved === claimed ? null : (
        <span className="text-xs text-muted-foreground"> / {formatNumber(approved)}</span>
      )}
    </span>
  );
}
